module.exports = __webpack_public_path__ + "static/media/credits.f3b791d8.svg";